/**
 * Copyright Highway9 Networks Inc.
 */
import { CircularProgress } from "@h9/ui-lib";

export function Loading() {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress color="primary" />
    </div>
  );
}
